/* eslint-disable */
<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <iq-card class="px-3 py-3">
          <template v-slot:body>
            <p v-if="!propOpenedInModal">{{ cvCardTitle }}</p>
            <form action="#">
              <div class="form-row">
                <!-- Agent ID -->
                <div class="col-md-12 mb-3">
                  <label>{{ cvAgentIdLabel }}</label>
                  <input v-model="vmWrkAgentFormData.agent_id" type="text" class="form-control" placeholder="E.g: AGNT_EMAIL_SCHEDULE_COUNSELING_SESSION" required/>
                </div>
                <!-- Agent Name -->
                <div class="col-md-12 mb-3">
                  <label>{{ cvAgentNameLabel }}</label>
                  <input v-model="vmWrkAgentFormData.agent_name" type="text" class="form-control" placeholder="Enter Agent Name" required/>
                </div>
                <!-- Agent Description -->
                <div class="col-md-12 mb-3">
                  <label>{{ cvAgentDescLabel }}</label>
                  <b-form-textarea v-model="vmWrkAgentFormData.agent_desc" rows="6" max-rows="12" placeholder="Enter Agent Description..." required/>
                </div>
                <!-- Module Name -->
                <div class="col-md-12 mb-3">
                  <label>{{ cvModuleNameLabel }}</label>
                  <!-- <input v-model="vmWrkAgentFormData.module_name" type="text" class="form-control" placeholder="Enter Module Name" required/> -->
                  <select
                    v-model="vmWrkAgentFormData.module_name"
                    class="form-control"
                    required
                  >
                    <option value="" disabled>Select Module</option>
                    <option v-for="(module,index) in propModules" :key="index" :value="module.mod_name">{{ module.mod_name }}</option>
                  </select>
                </div>
                <!-- Action -->
                <div class="col-md-12 mb-3">
                  <label>{{ cvActionLabel }}</label>
                  <b-form-textarea v-model="vmWrkAgentFormData.action" rows="4" max-rows="8" placeholder="Schedule counseling session, stream-selection, career-selection" required/>
                </div>
                <!-- App Domain -->
                <div class="col-md-12 mb-3">
                  <label>{{ cvAppDomainLabel }}</label>
                  <input v-model="vmWrkAgentFormData.agent_app_domain" type="text" class="form-control" placeholder="gide.ai" required/>
                </div>
                <button :disabled="cvLoadingStatus" type="button" class="btn btn-primary mx-2" @click="wrkAgentAdd()">{{ cvSubmitBtn }}</button>
              </div>
            </form>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <b-toast v-model="showToast" name="Toast" :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { socialvue } from "../../../config/pluginInit"
import { WrkAgentApiObj } from "../../../FackApi/api/wrkAgent.js"

export default {
  name: "wrkAgentAdd",
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propModules: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      cvCardTitle: "Add Agent",
      cvSubmitBtn: "Add",
      cvAgentIdLabel: "Agent Id",
      cvAgentNameLabel: "Agent Name",
      cvAgentDescLabel: "Agent Description",
      cvModuleNameLabel: "Module Name",
      cvActionLabel: "Action",
      cvAppDomainLabel: "App Domain",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "Agent",
      cvLoadingStatus: false,
      vmWrkAgentFormData: Object.assign({}, this.initFormData())
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  mounted () {
    socialvue.index()
  },
  methods: {
    /**
     * initFormData
     */
    initFormData () {
      return {
        agent_id: "",
        agent_name: "",
        agent_desc: "",
        module_name: "",
        action: "",
        agent_app_domain: ""
      }
    },
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmWrkAgentFormData) {
          const value = this.vmWrkAgentFormData[index]
          if (!String(value || "").trim()) {
            if (index === "agent_app_domain") {
              this.toastMsg = "Missing App Domain"
            }
            else {
              this.toastMsg = "Missing " + index.split("_").join(" ")
            }
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }

          // agent_id validation
          if (index === "agent_id") {
            const validFormat = /^[A-Z0-9_]+$/
            if (!validFormat.test(this.vmWrkAgentFormData[index])) {
              this.toastMsg = "Agent ID must contain only uppercase letters, numbers and underscores"
              this.toastVariant = "danger"
              this.showToast = true
              return false
            }
          }

          // agent_app_domain validation
          if (index === "agent_app_domain") {
            const domainRegex = /^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
            if (!domainRegex.test(this.vmWrkAgentFormData[index])) {
              this.toastMsg = "Please enter a valid domain"
              this.toastVariant = "danger"
              this.showToast = true
              return false
            }
          }
        }

        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
      }
    },
    /**
     * wrkAgentAdd
     */
    async wrkAgentAdd () {
      if (!this.validate()) {
        return false
      }

      try {
        this.cvLoadingStatus = true
        let wrkAgentAddResp = await WrkAgentApiObj.wrkAgentAdd(this, this.vmWrkAgentFormData)
        if (wrkAgentAddResp && !wrkAgentAddResp.resp_status) {
          this.toastMsg = wrkAgentAddResp.resp_msg || "Failed to add agent"
          this.toastVariant = "danger"
          this.showToast = true
          return false
        }

        this.toastMsg = "Agent added successfully"
        this.toastVariant = "success"
        this.showToast = true
        if (this.propOpenedInModal) {
          this.$emit("emitCloseWrkAgentAddModal")
        }

        this.vmWrkAgentFormData = Object.assign({}, this.initFormData())
      }
      catch (err) {
        console.error("Exception occurred at wrkAgentAdd() and Exception:", err.message)
        this.toastMsg = "Failed to add agent"
        this.toastVariant = "danger"
        this.showToast = true
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
